import { render, staticRenderFns } from "./TestWrapper.vue?vue&type=template&id=964c954a&scoped=true"
import script from "./TestWrapper.vue?vue&type=script&lang=js"
export * from "./TestWrapper.vue?vue&type=script&lang=js"
import style0 from "./TestWrapper.vue?vue&type=style&index=0&id=964c954a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964c954a",
  null
  
)

export default component.exports